<template>
  <div class="app-container paiwei robot-content">
    <Header></Header>

    <div class="audio-test-container">
      <!-- 连接状态显示 -->
      <div class="status-panel">
        <h3>音效测试面板</h3>
        <div class="status-item">
          <span class="status-label">音频状态：</span>
          <span class="status-value" :class="{'connected': audioUnlocked}">
            {{ audioUnlocked ? '已解锁' : '未解锁(需点击任意按钮激活)' }}
          </span>
        </div>
        <div class="status-item">
          <span class="status-label">背景音乐：</span>
          <span class="status-value">{{ bgmPlaying ? '播放中' : '未播放' }}</span>
        </div>
      </div>

      <!-- 背景音乐控制 -->
      <div class="control-group">
        <h4>背景音乐控制</h4>
        <button class="btn btn-blue" @click="startBackgroundMusic">播放背景音乐</button>
        <button class="btn btn-red" @click="stopMusic">停止背景音乐</button>
        <button class="btn btn-orange" @click="fadeOutMusic">淡出背景音乐</button>
      </div>

      <!-- 基础音效测试 -->
      <div class="control-group">
        <h4>基础音效测试</h4>
        <button class="btn btn-green" @click="playSound('basic.correct')">正确音效</button>
        <button class="btn btn-red" @click="playSound('basic.wrong')">错误音效</button>
        <button class="btn btn-gray" @click="playSound('basic.click')">点击音效</button>
      </div>

      <!-- 特殊音效测试 -->
      <div class="control-group">
        <h4>特殊音效测试</h4>
        <button class="btn btn-purple" @click="playSound('sfx.countdown')">倒计时音效</button>
        <button class="btn btn-gold" @click="playSound('sfx.win')">胜利音效</button>
        <button class="btn btn-silver" @click="playSound('sfx.lose')">失败音效</button>
      </div>

      <!-- 音量控制 -->
      <div class="control-group">
        <h4>音量控制</h4>
        <div class="volume-control">
          <button class="btn btn-small" @click="setVolume(0.2)">20%</button>
          <button class="btn btn-small" @click="setVolume(0.5)">50%</button>
          <button class="btn btn-small" @click="setVolume(0.8)">80%</button>
          <button class="btn btn-small" @click="setVolume(1)">100%</button>
        </div>
        <div>当前音量：{{ currentVolume * 100 }}%</div>
      </div>

      <!-- 音效队列测试 -->
      <div class="control-group">
        <h4>音效队列测试</h4>
        <button class="btn btn-teal" @click="playSequence">播放序列(倒计时→正确→胜利)</button>
      </div>

      <!-- 音频权限提示 -->
      <div v-if="showAudioPermission" class="permission-panel">
        <div class="permission-content">
          <p>需要您的授权才能播放音效</p>
          <button class="btn btn-primary" @click="unlockAudio">允许播放音效</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from '../components/HeaderOne'
import Dialog from '../components/dialog'

export default {
  components: {
    Header, Dialog
  },
  name: 'AudioTestPage',
  data() {
    return {
      audioUnlocked: false,
      bgmPlaying: false,
      showAudioPermission: false,
      currentVolume: 1,
      lastPlayedSound: null
    }
  },
  mounted() {
    // 监听音频服务状态
    this.$audio.audioUnlocked = false;

    // 尝试初始化音频
    this.initAudio();
  },
  methods: {
    // 初始化音频
    initAudio() {
      this.$audio.init();
      this.audioUnlocked = this.$audio.audioUnlocked;
    },

    // 播放指定音效
    playSound(soundName) {
      this.lastPlayedSound = soundName;
      this.$audio.play(soundName)
        .then(() => {
          console.log(`${soundName} 播放成功`);
        })
        .catch(e => {
          if (e.message === 'AUDIO_NOT_UNLOCKED') {
            this.showAudioPermission = true;
          }
          console.error(`${soundName} 播放失败:`, e);
        });
    },

    // 开始背景音乐
    startBackgroundMusic() {
      this.$audio.play('bgm.main', {loop: true})
        .then(() => {
          this.bgmPlaying = true;
          console.log('背景音乐开始播放');
        })
        .catch(e => {
          if (e.message === 'AUDIO_NOT_UNLOCKED') {
            this.showAudioPermission = true;
          }
          console.error('背景音乐播放失败:', e);
        });
    },

    // 停止背景音乐
    stopMusic() {
      this.$audio.stopBackground();
      this.bgmPlaying = false;
      console.log('背景音乐已停止');
    },

    // 淡出背景音乐
    fadeOutMusic() {
      this.$audio.fadeOut()
        .then(() => {
          this.bgmPlaying = false;
          console.log('背景音乐已淡出');
        });
    },

    // 解锁音频
    unlockAudio() {
      this.showAudioPermission = false;
      this.$audio.setupUnlockHandler();

      // 尝试重新播放上次失败的音效
      if (this.lastPlayedSound) {
        this.playSound(this.lastPlayedSound);
      }
    },

    // 设置音量
    setVolume(volume) {
      this.currentVolume = volume;
      this.$audio.setMasterVolume(volume);
      console.log(`音量设置为: ${volume * 100}%`);
    },

    // 播放音效序列
    playSequence() {
      this.$audio.enqueue('sfx.countdown')
        .then(() => this.$audio.enqueue('basic.correct'))
        .then(() => this.$audio.enqueue('sfx.win'))
        .then(() => console.log('音效序列播放完成'))
        .catch(e => console.error('音效序列播放失败:', e));
    }
  }
}
</script>

<style scoped>
.audio-test-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

.status-panel {
  background: #f5f5f5;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.status-item {
  display: flex;
  margin: 10px 0;
}

.status-label {
  font-weight: bold;
  min-width: 120px;
}

.status-value {
  color: #666;
}

.status-value.connected {
  color: #4CAF50;
  font-weight: bold;
}

.control-group {
  background: #fff;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 20px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.control-group h4 {
  margin-top: 0;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.btn {
  margin: 5px;
  padding: 8px 15px;
  border: none;
  border-radius: 4px;
  color: white;
  cursor: pointer;
  transition: all 0.3s;
}

.btn:hover {
  opacity: 0.9;
  transform: translateY(-2px);
}

.btn-small {
  padding: 5px 10px;
  font-size: 12px;
}

.btn-blue {
  background: #2196F3;
}

.btn-red {
  background: #F44336;
}

.btn-green {
  background: #4CAF50;
}

.btn-orange {
  background: #FF9800;
}

.btn-purple {
  background: #9C27B0;
}

.btn-gold {
  background: #FFD700;
  color: #333;
}

.btn-silver {
  background: #C0C0C0;
  color: #333;
}

.btn-teal {
  background: #009688;
}

.btn-gray {
  background: #9E9E9E;
}

.volume-control {
  display: flex;
  gap: 10px;
  margin: 10px 0;
}

.permission-panel {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.permission-content {
  background: white;
  padding: 30px;
  border-radius: 8px;
  text-align: center;
  max-width: 400px;
}

.permission-content p {
  margin-bottom: 20px;
  font-size: 16px;
}

.btn-primary {
  background: #2196F3;
  padding: 10px 20px;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/page/testMusic.vue